import { ECategory } from '../../../types/share';

export function mapCategoryValueToAnalytics(category: ECategory) {
  const mapper = {
    [ECategory.FlatSale]: 'flat_old/sale',
    [ECategory.FlatRent]: 'rent_long/rent',
    [ECategory.DailyFlatRent]: 'rent_day/rent',
    [ECategory.NewBuildingFlatSale]: 'flat_new/sale',
    [ECategory.CommercialSale]: 'commercial/rent',
    [ECategory.CommercialRent]: 'commercial/sale',
    [ECategory.SuburbanRent]: 'suburban/rent',
    [ECategory.SuburbanSale]: 'suburban/sale',
  };

  return mapper[category];
}
